import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, routerShape } from 'react-router';

import { viewStatus as viewStatusPropType } from './safeTradePropTypes.js';

class SafeTradeBuyerStatus extends PureComponent {
    componentWillMount() {
        const { router, viewStatus, viewStatusToUrl } = this.props;

        const url = viewStatusToUrl[viewStatus];

        if (url) {
            router.replace(url);
        } else {
            router.replace('/samtale');
        }
    }

    render() {
        return null;
    }
}

SafeTradeBuyerStatus.propTypes = {
    router: routerShape,
    viewStatus: viewStatusPropType.isRequired,
    viewStatusToUrl: PropTypes.objectOf(PropTypes.string).isRequired,
};

function mapStateToProps(state) {
    return {
        viewStatus: state.safeTrade.viewStatus,
    };
}

export default compose(connect(mapStateToProps), withRouter)(
    SafeTradeBuyerStatus
);



// WEBPACK FOOTER //
// ./safeTrade/latestStatus.jsx